import { useSyncExternalStore } from "react";

/**
 * "Open this project": an agent's ⋯ menu hands a project id to the Projects page,
 * which opens that project's sheet. Kept out of the view (and so out of the stored
 * workspace and saved layouts), like `agent-focus.ts`: a one-off instruction to the
 * page about to show, not a place to come back to.
 */
let pending: string | null = null;
const listeners = new Set<() => void>();

export function focusProject(projectId: string): void {
  pending = projectId;
  for (const listener of listeners) listener();
}

/** Taken once by the Projects page that opens it. */
export function takeProjectFocus(): string | null {
  const projectId = pending;
  pending = null;
  if (projectId) for (const listener of listeners) listener();
  return projectId;
}

/** Re-renders when a request arrives, so an already open Projects page opens it too. */
export function useProjectFocusRequest(): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => pending,
  );
}
